module.exports = __webpack_public_path__ + "static/media/400045_01.efcda266.png";